
























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { productAssignmentService } from '../../services/ProductAssignmentService'
import icon from '../assignment/icon.vue'
import AdminConfiguration from '@/interfaces/AdminConfiguration.interface'
import { Getter } from 'vuex-class'
import { ProductAdminSettingsInterface } from '@/interfaces/ProductAdminSettings.interface'
import axios from 'axios'

@Component({
  components: {
    icon,
  },
})
export default class ProductAssignmentViewComponent extends Vue {
  @Prop() readonly config: AdminConfiguration | any
  @Getter('products/selectedProduct') product
  @Getter('products/dateAttributes') productDateAttributes
  @Getter('products/selectedProductMember') selectedProductMember

  private isValid: unknown = null
  private validationComplete: unknown = null
  private loading: boolean = false
  private camera: string = 'off'
  private result: string = ''
  private scanEnabled: boolean = false
  private usedScanner: boolean = false
  private failedValidation: boolean = false
  private error: string = ''
  private currentButtonStateProxy: string = 'init'
  private userName: string = ''
  private firstName: string = ''
  private lastName: string = ''
  private mediaAssigned: boolean = false
  private legacyContactId: string = ''
  private validationMessage: string = ''
  private isFastFlowEnabled: boolean = false
  private isPassScanEnabled: boolean = false
  private productSettings: ProductAdminSettingsInterface | null = null
  private unAssignableHouseHoldContactIds: number[] = []
  private qrCodeRegex: string = ''
  private initialLoad: boolean = true
  private member: any = null

  async mounted() {
    this.qrCodeRegex = this.config.productAssignmentSettings.qrCodeFormat
    window.addEventListener('cart:condition:added', this.handleAddedToCart)
    window.addEventListener('group-member:updated', this.handleGroupMemberUpdate)
    window.addEventListener('group-member:component:created', this.handleGroupMemberComponentCreated)
    window.addEventListener('group-member:member:added', this.handleGroupMemberDataUpdate)
    window.addEventListener('group-member:member:media:updated', this.handleGroupMemberDataUpdate)
    window.addEventListener('pdp:assign-product:clear', this.handleClearProductAssignment)
    window.addEventListener('product:attributes:updated', this.handleProductAttributeChanged)
  }

  destroyed() {
    window.dispatchEvent(new CustomEvent('pdp:add-to-cart-disabled:updated', { detail: false }))
  }

  @Watch('product', { deep: true })
  async onProductChanged(to, from) {
    if (from?.Id != to?.Id) {
      this.isFastFlowEnabled = false
      if (to) {
        this.productSettings = await productAssignmentService.getProductAdminSettings(to.Id)
        this.isFastFlowEnabled = this.productSettings.IsFastFlowEnabled
        this.isPassScanEnabled = this.productSettings.IsPassScanEnabled
        if (this.productSettings.QrCodeFormat) {
          this.qrCodeRegex = this.productSettings.QrCodeFormat
        }
        if (this.isFastFlowEnabled) {
          this.resetComponentState()
          window.dispatchEvent(new CustomEvent('pdp:set-product-type', { detail: 'fastflow' }))
        }
        window.dispatchEvent(new CustomEvent('pdp:add-to-cart-disabled:updated', { detail: this.isFastFlowEnabled }))
      }
    }
  }

  @Watch('selectedProductMember')
  async onSelectedProductMember(to, from) {
    if (this.isFastFlowEnabled) {
      if (this.member) {
        window.dispatchEvent(new CustomEvent('pdp:assign-product', { detail: this.member }))
      }
    }
  }

  async onInit(promise): Promise<any> {
    this.loading = true
    try {
      await promise
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
      this.resetValidationState()
    }
  }

  // Event Handlers
  private handleClearProductAssignment() {
    if (this.legacyContactId && this.isFastFlowEnabled) {
      this.resetComponentState()
    }
  }

  private handleGroupMemberUpdate(evnt: any): void {
    if (this.isFastFlowEnabled) {
      this.resetComponentState()
      window.dispatchEvent(new CustomEvent('pdp:add-to-cart-disabled:updated', { detail: false }))
    }
  }

  private async handleGroupMemberDataUpdate() {
    if (this.isFastFlowEnabled) {
      await this.getUnassignableContacts()
    }
  }

  private async handleGroupMemberComponentCreated() {
    if (this.isFastFlowEnabled) {
      await this.getUnassignableContacts()
    }
  }

  private async handleProductAttributeChanged() {
    if (this.isFastFlowEnabled) {
      const legacyContactId = this.legacyContactId
      window.dispatchEvent(new CustomEvent('pdp:add-to-cart-disabled:updated', { detail: true }))
      await this.getUnassignableContacts()
      if (legacyContactId) {
        await this.handleValidation(this.result, this.usedScanner)
      } else {
        if (this.initialLoad && this.isProductStartDateValid) {
          let urlParams = new URLSearchParams(window.location.search)
          let mediaId = urlParams.get('mediaId')
          if (mediaId) {
            this.result = mediaId
            await this.handleValidation(this.result, true)
            this.initialLoad = false
          }
        }
      }
    }
  }

  private async handleAddedToCart(evt) {
    if (this.isFastFlowEnabled) {
      const shoppingCartItemId = evt?.detail?.addToCartResponse?.shoppingCartItemId
      const contactId = this.legacyContactId
      if (shoppingCartItemId !== null && contactId !== '') {
        await productAssignmentService.assignShoppingCartItem(
          shoppingCartItemId,
          contactId,
          this.firstName,
          this.lastName
        )
        this.mediaAssigned = true
        this.isValid = true
      }
    }
  }

  private async handleValidation(val: string, isManual: boolean): Promise<any> {
    if (this.isFastFlowEnabled) {
      window.dispatchEvent(new CustomEvent('group-member:reset'))
      if (isManual && this.scanEnabled) {
        this.disableScan()
      }
      const data = val
      await this.timeout(100)
      this.validateUser(data)
    }
  }

  // Methods
  private async validateUser(idToValidate): Promise<void> {
    const id = idToValidate
    this.currentButtonState = 'await'
    productAssignmentService
      .fetchMediaInfo(id, this.product.Id, this.productStartDate, this.product.ProductHeaderCode, this.usedScanner)
      .then((val) => {
        this.validationMessage = val.Message
        if (val.Status == 'Valid') {
          this.legacyContactId = val.LegacyContactId
          this.userName = `${val.FirstName} ${val.LastName}`
          this.firstName = val.FirstName
          this.lastName = val.LastName
          this.currentButtonState = 'valid'
          // send event to pdp enabling the add to cart button
          window.dispatchEvent(new CustomEvent('pdp:add-to-cart-disabled:updated', { detail: false }))
          this.member = {
            ContactInfoId: -1 * Number(val.LegacyContactId), // A real contact record does not exist right now, set value to negative legacy contact id for randomness
            FirstName: this.firstName,
            LastName: this.lastName,
            AgeDescription: '',
            IsAssignable: true,
            PhotoUrl: null,
            Rfid: null,
            PassMediaNumber: null,
            DateOfBirth: val.BirthDate,
            ReservationDatesInfo: {
              ReservedDaysCount: 0,
              Message: null,
              BookedReservationDates: [],
              InCartReservationDates: [],
            },
            ExcludeFromHousehold: true,
            LegacyContactId: val.LegacyContactId,
            SlimOptions: null,
          }

          window.dispatchEvent(new CustomEvent('pdp:assign-product', { detail: this.member }))
          window.dispatchEvent(new CustomEvent('pdp:assignable-members:refresh', { detail: null }))
          //emitEvent(AxEventType.MemberSelected, this.member)
        } else {
          this.currentButtonState = 'invalid'
        }
      })
      .catch((err) => {
        this.error = err.response.data.message ?? err
        this.currentButtonState = 'invalid'
      })
  }

  private enableScan(): void {
    if (this.isProductStartDateValid) {
      this.turnCameraOn()
      if (!this.validationComplete || this.failedValidation) {
        this.scanEnabled = true
      }
    }
  }

  private disableScan(): void {
    this.scanEnabled = false
  }

  async onDecode(content) {
    this.turnCameraOff()

    if (this.qrCodeRegex) {
      let matches = content.match(this.qrCodeRegex)
      if (matches && matches.length >= 2) {
        // Grab Group #1
        this.result = matches[1]
      }
    } else {
      this.result = content
    }

    await this.handleValidation(this.result, false)
    this.usedScanner = true
    // give user a chance to read message
    await this.timeout(2000)
    this.disableScan()
  }

  private turnCameraOn(): void {
    this.camera = 'auto'
  }

  private turnCameraOff(): void {
    this.camera = 'off'
  }

  private async timeout(ms): Promise<any> {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms)
    })
  }

  private async getUnassignableContacts() {
    if (this.product.IsReservationProduct) {
      this.unAssignableHouseHoldContactIds = []
      return
    }
    window.dispatchEvent(new CustomEvent('group-member:loading', { detail: true }))
    this.unAssignableHouseHoldContactIds = await productAssignmentService.fetchUnAssignableHouseholdContacts(
      '',
      this.product.Id,
      this.productStartDate,
      this.product.ProductHeaderCode,
      this.usedScanner
    )

    if (this.unAssignableHouseHoldContactIds) {
      window.dispatchEvent(
        new CustomEvent('group-member:unassignable-members:update', { detail: this.unAssignableHouseHoldContactIds })
      )
    }
    window.dispatchEvent(new CustomEvent('group-member:loading', { detail: false }))
  }

  private resetValidationState(): void {
    this.isValid = null
  }

  private resetComponentState(shouldClearCustomer: boolean = false): void {
    window.dispatchEvent(new CustomEvent('pdp:add-to-cart-disabled:updated', { detail: true }))
    this.validationComplete = null
    this.result = ''
    this.error = ''
    this.legacyContactId = ''
    this.loading = false
    this.failedValidation = false
    this.member = null
    this.mediaAssigned = false
    this.userName = ''
    this.resetValidationState()
    this.currentButtonState = 'init'
    if (this.usedScanner) {
      this.camera = 'auto'
      this.enableScan()
      this.usedScanner = false
    }

    if (shouldClearCustomer == true) {
      window.dispatchEvent(new CustomEvent('pdp:assign-product', { detail: null }))
    }
  }

  // Computed Properties
  get currentButtonState() {
    return this.currentButtonStateProxy
  }

  set currentButtonState(state) {
    switch (state) {
      case 'await':
        this.validationComplete = false
        this.currentButtonStateProxy = 'await'
        break
      case 'valid':
        this.isValid = true
        this.validationComplete = true
        this.currentButtonStateProxy = 'valid'
        break
      case 'invalid':
        this.isValid = false
        this.failedValidation = true
        this.validationComplete = true
        this.currentButtonStateProxy = 'invalid'
        break
      case 'init':
        this.currentButtonStateProxy = 'init'
        break
    }
  }

  get validationPending(): boolean {
    return this.isValid === null && this.camera === 'off'
  }

  get validationSuccess(): boolean {
    return this.isValid === true
  }

  get validationFailure(): boolean {
    return this.isValid === false
  }

  get validatedMessage(): string {
    let message = this.config.languageStrings.messageValidatedText
    message = message.replace('{{username}}', this.userName)
    message = message.replace('{{message}}', this.validationMessage)
    return message
  }

  get invalidMessage(): string {
    if (this.error != null && this.error != '') {
      return this.error
    }
    let message = this.config.languageStrings.messageInvalidText
    message = message.replace('{{message}}', this.validationMessage)
    return message
  }

  get mediaAssignedMessage(): string {
    let message = this.config.languageStrings.messageMediaAssignedText
    message = message.replace('{{username}}', this.userName)
    return message
  }

  get productStartDate(): string {
    let startDateAttribute = this.productDateAttributes.find((i) => i.Name == 'Start Date')
    return startDateAttribute?.SelectedValueId
  }

  get hasProductStartDate(): boolean {
    let startDateAttribute = this.productDateAttributes.find((i) => i.IsRequired == true && i.Name == 'Start Date')
    return startDateAttribute != null
  }

  get isProductStartDateValid(): boolean {
    if (!this.hasProductStartDate) {
      return true
    }

    let startDateAttribute = this.productDateAttributes.find((i) => i.Name == 'Start Date')
    return startDateAttribute.SelectedValueId != null
  }

  get title(): string {
    return this.productSettings?.LanguageTitle ?? this.config.languageStrings.title
  }

  get subtitle(): string {
    return this.productSettings?.LanguageSubTitle ?? this.config.languageStrings.subTitle
  }

  get placeholder(): string {
    return this.productSettings?.LanguageTextboxPlaceholder ?? this.config.languageStrings.textboxPlaceholder
  }
}
